import React from 'react'
import { Link } from 'react-router-dom'
import BreadCrum from '../components/BreadCrum'
import Meta from '../components/Meta'
import {HiOutlineArrowLeft} from 'react-icons/hi'
import blog from '../images/blog-1.jpg'
import Container from '../components/Container'
const SingleBlog = () => {
  return (
    <>
        <Meta title='Daynamic Blog Name'/>
        <BreadCrum title='Daynamic Blog Name' />
        <Container className="blog-wrapper home-wrapper-2 py-5">
            <div className="row">
                <div className="col-12">
                    <div className="single-blog-card">
                        <Link to="/blogs" className="d-flex align-items-center gap-10">
                            <HiOutlineArrowLeft className='fs-4' /> Go Back
                        </Link>
                        <h3 className='title'>Lorem, ipsum dolor.</h3>
                        <img src={blog} alt="blog" className='w-100 img-fluid my-4' />
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti, blanditiis aliquid nobis minus voluptates corporis quas tempora delectus autem cum consequuntur ducimus sed fuga tenetur perferendis illo repellat quis inventore ipsam omnis dolor atque deserunt obcaecati? Esse, repellat delectus. Nihil, quos harum id eveniet laborum iste mollitia aut? Sint error facilis fugiat voluptates, architecto quod modi laboriosam ullam ipsa beatae eos, impedit esse harum? Doloribus esse rem ratione obcaecati minus vel ducimus debitis temporibus neque in mollitia, atque, et nisi aspernatur incidunt sequi iure iste. Ratione possimus autem ut, praesentium quos voluptates libero nobis et repellat, expedita minus sunt vero.
                        </p>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default SingleBlog